import * as types from '../actions/actionTypes'

const initialState = {
    isLoading: false,

    places: [
        { id: '1', name: 'Alba' },
        { id: '2', name: 'Arad' },
        { id: '3', name: 'Argeș' },
        { id: '4', name: 'Bacău' },
        { id: '5', name: 'Bihor' },
        { id: '6', name: 'Bistrița-năsăud' },
        { id: '7', name: 'Botoșani' },
        { id: '8', name: 'Brăila' },
        { id: '9', name: 'Brașov' },
        { id: '42', name: 'București' },
        { id: '10', name: 'Buzău' },
        { id: '11', name: 'Călărași' },
        { id: '12', name: 'Caraș-severin' },
        { id: '13', name: 'Cluj' },
        { id: '14', name: 'Constanța' },
        { id: '15', name: 'Covasna' },
        { id: '16', name: 'Dâmbovița' },
        { id: '17', name: 'Dolj' },
        { id: '18', name: 'Galați' },
        { id: '19', name: 'Giurgiu' },
        { id: '20', name: 'Gorj' },
        { id: '21', name: 'Harghita' },
        { id: '22', name: 'Hunedoara' },
        { id: '23', name: 'Ialomița' },
        { id: '24', name: 'Iași' },
        { id: '25', name: 'Ilfov' },
        { id: '26', name: 'Maramureș' },
        { id: '27', name: 'Mehedinți' },
        { id: '28', name: 'Mureș' },
        { id: '29', name: 'Neamț' },
        { id: '30', name: 'Olt' },
        { id: '31', name: 'Prahova' },
        { id: '32', name: 'Sălaj' },
        { id: '33', name: 'Satu Mare' },
        { id: '34', name: 'Sibiu' },
        { id: '35', name: 'Suceava' },
        { id: '36', name: 'Teleorman' },
        { id: '37', name: 'Timiș' },
        { id: '38', name: 'Tulcea' },
        { id: '39', name: 'Vaslui' },
        { id: '40', name: 'Vâlcea' },
        { id: '41', name: 'Vrancea' }
    ]
}

export default function placesReducer(state = initialState, action) {
    switch (action.type) {
        case types.PLACES_IS_LOADING:
            console.log(action)

            return Object.assign({}, state, {
                isLoading: true
            })

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/placesReducer.js